import { EMPTY_LIST } from '../../../constants/common'
import { FilterDivider } from '../../FilterDivider'
import { PageActions } from '../../Page'
import { Pagination } from '../../Pagination'
import { SelectionToolbar } from '../../SelectionToolbar'
import {
  getSelectedSize,
  Table,
  TableConfigModal,
  TableContext,
  TableControlBar,
  TableControlButtons,
  TableMassAction,
} from '../../Table'
import { EMAIL_TABLE_ROW_ACTIONS_WIDTH } from '../Email.constants'
import { EmailTableRow } from '../EmailTableRow'

import * as styles from './EmailTableLayout.module.css'

function EmailTableLayout({
  ChangeViewTypeButton = null,
  actionsColumnWidth = EMAIL_TABLE_ROW_ACTIONS_WIDTH,
  arrowNavigationConfig,
  changeViewTypeButtonProps,
  emptyState = null,
  extraModals = null,
  getItemActions,
  hasTable,
  massActions = EMPTY_LIST,
  modal = null,
  rowExtraProps,
  setItemAction,
  setMassAction,
  skeletonProps,
  tablePage,
  withRowActions = true,
  onChangeFocusedRow,
}) {
  const {
    checkIsItemSelected,
    columns,
    entity,
    exclude,
    handleApply,
    handleConfigOpen,
    handleExclude,
    handleSelect,
    handleSelectAll,
    handleSelectAllPages,
    handleSetColumns,
    handleSetPagination,
    handleSetSize,
    handleUnselectAllPages,
    isAllSelected,
    isConfigOpen,
    isLoading,
    isRemoveSelection,
    items,
    pageScrollWrapperRef,
    pagination,
    refreshButtonProps,
    requiredColumns,
    selectAllPages,
    selected,
    setConfigOpen,
  } = tablePage

  const hasMassActions = massActions.length > 0

  return (
    <>
      {hasTable ? (
        <>
          <TableControlBar>
            {hasMassActions ? (
              <TableMassAction
                responsive
                actions={massActions}
                isAllSelected={isAllSelected}
                isLoading={isLoading}
                isRemoveSelection={isRemoveSelection}
                selectedSize={getSelectedSize({
                  exclude,
                  pagination,
                  selectAllPages,
                  selected,
                })}
                setMassAction={setMassAction}
                onSelectAll={handleSelectAll}
              />
            ) : null}
            <PageActions className={styles.pageActions} isLoading={isLoading}>
              <TableControlButtons
                ChangeViewTypeButton={ChangeViewTypeButton}
                DensityButton={null}
                ResetSortingButton={null}
                changeViewTypeButtonProps={changeViewTypeButtonProps}
                configButtonProps={{ onClick: handleConfigOpen }}
                refreshButtonProps={refreshButtonProps}
              />
              <FilterDivider />
              <Pagination
                responsive
                value={pagination}
                onChange={handleSetPagination}
                onChangeSize={handleSetSize}
              />
            </PageActions>
          </TableControlBar>
          <Table
            TableRow={EmailTableRow}
            actionsColumnWidth={withRowActions ? actionsColumnWidth : 0}
            arrowNavigationConfig={arrowNavigationConfig}
            checkIsItemSelected={checkIsItemSelected}
            columns={columns}
            containerRef={pageScrollWrapperRef}
            context={TableContext.Emails}
            headerRowProps={{
              onApply: handleApply,
              onSetColumns: handleSetColumns,
            }}
            isLoading={isLoading}
            items={items?.items}
            rowProps={{
              ...rowExtraProps,
              Actions: withRowActions ? undefined : null,
              getActions: getItemActions,
              hideCheckbox: !hasMassActions,
              onCallAction: setItemAction,
              onSelect: selectAllPages ? handleExclude : handleSelect,
            }}
            skeletonProps={skeletonProps}
            onChangeFocusedRow={onChangeFocusedRow}
          />
        </>
      ) : (
        emptyState
      )}
      {selected.length > 0 || selectAllPages ? (
        <SelectionToolbar
          allSelected={selectAllPages || selected.length === pagination.count}
          count={pagination.count}
          excludeCount={exclude.length}
          selected={selected.length}
          onClose={handleUnselectAllPages}
          onSelectAll={handleSelectAllPages}
        />
      ) : null}
      {isConfigOpen ? (
        <TableConfigModal
          columns={columns}
          entity={entity}
          requiredColumns={requiredColumns}
          setColumns={handleSetColumns}
          setConfigOpen={setConfigOpen}
          onApply={handleApply}
        />
      ) : null}
      {modal}
      {extraModals}
    </>
  )
}

export default EmailTableLayout
